import React from 'react';
import Icon from '../../../atoms/Icon';
import AddressOptionProps from './AddressOption.types';
import styles from './AddressOption.module.scss';

const AddressOption = ({ text, description, isGroup }: AddressOptionProps) => (
  <div className={styles.addressOption}>
    <span className={styles.title}>
      <span>{text}</span>
      <span className={styles.label}>{description}</span>
    </span>
    {isGroup && (
      <span className={styles.icon}>
        <Icon
          className={styles.chevronRight}
          icon='chevron'
          strokeWidth='0'
          fill='currentColor'
          width='14'
          height='8'
          viewBox='0 0 14 8'
        />
      </span>
    )}
  </div>
);

export default AddressOption;
